import {
    GET_APPEARANCE_LOGOS,
    GET_APPEARANCE_LOGOS_SUCCESS,
    UPLOAD_APPEARANCE_LOGO,
    UPLOAD_APPEARANCE_LOGO_SUCCESS,
    UPLOAD_APPEARANCE_LOGO_FAILURE,
    DELETE_APPEARANCE_LOGO,
    DELETE_APPEARANCE_LOGO_SUCCESS,
} from "./constants.js";

/**
 *
 * @returns {{type: string}}
 */
const getLogos = () => ({
    type: GET_APPEARANCE_LOGOS,
});

/**
 *
 * @param logos
 * @returns {{logos: *, type: string}}
 */
const getLogosSuccess = (logos) => ({
    type: GET_APPEARANCE_LOGOS_SUCCESS,
    logos,
});

/**
 *
 * @param tenantId
 * @param logo
 * @returns {{formData: *, type: string}}
 */
const uploadLogo = (tenantId, logo) => {
    const formData = new FormData();
    formData.append("tenant_id", tenantId);
    formData.append("file", logo);

    return {
        type: UPLOAD_APPEARANCE_LOGO,
        payload: formData,
    };
};

/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const uploadLogoSuccess = (result) => ({
    type: UPLOAD_APPEARANCE_LOGO_SUCCESS,
    payload: result,
});

/**
 *
 * @param errors
 * @returns {{errors: *, type: string}}
 */
const uploadLogoFailure = (errors) => ({
    type: UPLOAD_APPEARANCE_LOGO_FAILURE,
    payload: errors,
});

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const deleteLogo = (id) => ({
    type: DELETE_APPEARANCE_LOGO,
    id,
});

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const deleteLogoSuccess = (id) => ({
    type: DELETE_APPEARANCE_LOGO_SUCCESS,
    payload: id,
});

export {
    getLogos,
    getLogosSuccess,
    uploadLogo,
    uploadLogoSuccess,
    uploadLogoFailure,
    deleteLogo,
    deleteLogoSuccess,
};
